<template>
    <div class="modal fade custom-modal" id="editProjectAccess" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content custom-modal-content" v-if="projectId">
                <div class="dismiss-modal-btn" @click="closeOpenedModal()">
                    <i class="fad fa-times-circle"></i>
                </div>
                <div class="modal-header custom-modal-header">
                    <i class="fad fa-users"></i>
                    <h5 class="modal-title"> Editeaza acces </h5>
                </div>
                <div class="modal-body custom-modal-body">
                    <form id="form-edit-item-access">
                        <input type="hidden" name="type" value="building"/>
                        <input type="hidden" name="project" :value="projectId"/>

                        <div class="levels-container">
                            <div class="single-level-wrapper">
                                <h3><i class="fad fa-users"></i> Acces permis</h3>
                                <div class="add-field-btn"
                                     @click="addItemRow()">
                                    <i class="fad fa-plus-circle"></i> Adauga
                                </div>
                                <div class="single-level-row"
                                     v-for="(email, indexItem) in emails"
                                     :key="`row-${indexItem}`">
                                    <div class="row">
                                        <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11">
                                            <div class="level-item-nr level-strip-cell">
                                                <div class="input-container">
                                                    <div class="input-group mg-b">
                                                        <input type="email"
                                                               v-model="emails[indexItem]"
                                                               :id="`emails-${indexItem}`"
                                                               placeholder="Email">
                                                        <div class="input-icon">
                                                            <i class="fad fa-at"></i>
                                                        </div>
                                                        <label class="custom-label" :for="`emails-${indexItem}`"> Email </label>
                                                    </div>
                                                    <p class="custom-input-error" :id="`emails-${indexItem}_error`"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="single-level-row-availability">
                                    </div>
                                    <div class="remove-field-btn">
                                        <i class="fad fa-minus-circle"
                                           v-on:click="removeItemRow(indexItem)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer custom-modal-footer">
                    <button type="button" class="general-btn negative-btn" @click="dismissModal()">
                        <i class="fad fa-times-circle"></i>
                        <span> Inchide </span>
                    </button>
                    <button type="button" @click="save()" class="general-btn positive-btn">
                        <i class="fad fa-save"></i>
                        <span> Salveaza </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeveloperEditProjectAccess",
    data() {
        return {
            emails: [],
            projectId: null,
        }
    },
    created() {
    },
    mounted() {
        let vm = this
        $('#editProjectAccess').on('hidden.bs.modal', function () {
            $('#form-edit-item-access').trigger("reset");
            vm.projectId = null
        });
        this.$eventBus.$on('OPEN_EDIT_PROJECT_ACCESS_MODAL', function (payLoad) {
            vm.projectId = payLoad.projectId;
            vm.loadEmails();
            $('#editProjectAccess').modal('show')
        });
        $('#form-edit-item-access').submit(function (e) {
            e.preventDefault();
            vm.save();
        })
    },
    methods: {
        closeOpenedModal() {
            $('#editProjectAccess').modal('hide')
        },
        dismissModal() {
            $('#editProjectAccess').modal('hide')
            this.projectId = null;
            this.emails = [];
        },

        loadEmails() {
            let vm = this;
            window.axios.get(`/ajax/developer/project/${this.projectId}/access`)
                .then(function (response) {
                    let accessList = response.data.data;
                    vm.emails = [];
                    for (let i in accessList) {
                        vm.emails.push(accessList[i].email);
                    }
                })
                .catch(function () {
                    // console.log(err)
                    // window.showError(err)
                });
        },
        addItemRow: function () {
            this.emails.push('');
        },
        removeItemRow: function (index) {
            this.emails.splice(index, 1);
        },
        save() {
            window.resetErrors()
            let vm = this;
            let formData = new FormData();
            formData.append('emails', JSON.stringify(vm.emails));
            window.axios.post(`/ajax/developer/project/${this.projectId}/access`, formData)
                .then(function () {
                    window.Swal.fire({
                        html: 'Datele de acces au fost modificate cu succes',
                        icon: 'success',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(() => {
                        vm.projectId = null;
                        vm.emails = [];
                        $('#editProjectAccess').modal('hide')
                    })

                })
                .catch(function (err) {
                    vm.buttonDisable = false;
                    window.showError(err)
                });
        }
    }
}
</script>

<style scoped>

#editProjectAccess .levels-container .input-container {
    min-height: 30px;
    margin-bottom: 0;
}

#editProjectAccess .remove-field-btn {
    top: 12px;
}

#editProjectAccess .levels-container .single-level-wrapper h3 {
    margin-top: 0;
}

</style>
